export default {
  '***': {
    '***': []
  }
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/config/components/selection/Search/tagHierarchy.js